import React from 'react';
import { FillsGraphData } from 'widgets/fillsGraph/fillsGraphData';
import FillsGraphSettings from 'widgets/fillsGraph/settings/FillsGraphSettings';
import FillsGraphToolbarLegend from './FillsGraphToolbarLegend';
import './FillsGraphToolbar.scss';
import { FillsGraphConfiguration } from 'widgets/fillsGraph/store/configuration/FillsGraphConfiguration';
import SelectionStatus from 'portfolio/components/SelectionStatus';
import ZoomButtons from 'utils/components/Zoom/ZoomButtons';
import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';
import { FillsGraphPortfolioData } from 'widgets/fillsGraph/fillsGraphPortfolioData';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';
import { useWidgetMessages } from 'widgets/store/stream/selectors';

interface FillsGraphToolbarProps {
    avgExecAndVwapDecimals: number;
    fillsGraphData: FillsGraphData;
    fillsGraphPortfolioData?: FillsGraphPortfolioData;
    fillsGraphConfiguration: FillsGraphConfiguration;
    onFillsGraphConfigurationChange: (
        fillsGraphConfiguration: FillsGraphConfiguration
    ) => void;
}

export default function FillsGraphToolbar(props: FillsGraphToolbarProps) {
    const {
        fillsGraphData,
        fillsGraphPortfolioData,
        fillsGraphConfiguration,
        avgExecAndVwapDecimals,
        onFillsGraphConfigurationChange,
    } = props;

    const { hasValidSelection, portfolioSelectionRequirements } =
        useWidgetPortfolioSelectionStatus();

    const { externalMarketDataMessages } = fillsGraphData;
    const widgetMessages = useWidgetMessages();
    const messages = [...widgetMessages, ...externalMarketDataMessages];

    return (
        <div className="FillsGraphToolbar panel-header">
            <div className="toolbar">
                <SelectionStatus
                    widgetName="Fills Graph"
                    selectionRequirements={portfolioSelectionRequirements}
                />
                <FillsGraphToolbarLegend
                    fillsGraphData={fillsGraphData}
                    fillsGraphPortfolioData={fillsGraphPortfolioData}
                    avgExecAndVwapDecimals={avgExecAndVwapDecimals}
                />
            </div>
            <WidgetToolbar
                fixedItems={hasValidSelection ? <ZoomButtons /> : undefined}
                showEditLayout={hasValidSelection}
                settingsHeader="Fills Chart Settings"
                settingsClassName={'FillsGraphSettingsModal'}
                messages={messages}
                settingsBody={
                    <FillsGraphSettings
                        fillsGraphConfiguration={fillsGraphConfiguration}
                        onFillsGraphConfigurationChange={
                            onFillsGraphConfigurationChange
                        }
                    />
                }
            />
        </div>
    );
}
